import React from "react";
import { Checkbox } from "../../ui/checkbox";

export function CheckboxGroupField({
  item,
  value,
  error,
  helperText,
  disabled,
  onFieldChange,
  className,
  labelClassName
}) {
  const handleChange = (checked) => {
    // Handle single checkbox with boolean value at the specified path
    onFieldChange(item.pathToValue, checked, item.type, item);
  };

  return (
    <div className="space-y-2">
      {item.options?.map((option, index) => {
        const isChecked = value || false;
        
        return (
          <div key={`${item.uniqueField}-${index}`} className="flex items-start space-x-3">
            <Checkbox
              id={item.uniqueField}
              checked={isChecked}
              onCheckedChange={handleChange}
              disabled={disabled}
              error={error}
              label={option.label}
              errorMessage={error ? helperText : undefined}
              className={className}
              labelClassName={labelClassName}
            />
          </div>
        );
      })}
    </div>
  );
}
